import { Grid, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';

export const MemberImportWrapper = () => {
  const { t } = useTranslation(['member']);

  const tabs: PageTabItem[] = [
    {
      label: 'member:importMember.tabImport',
      route: RoutesEnum.ImportMembersUpload,
    },
    {
      label: 'member:importSessions.tabTitle',
      route: RoutesEnum.ImportMembersSessions,
    },
  ];

  return (
    <GridWrapper>
      <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
        <MainContentHeader title={t('member:importMember.header')} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <PageTabNavigation pageTabs={tabs} />
          <Outlet />
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
